import style from 'styles/global/stepper';

const { stepper, title } = style;

export default () => ({
  stepper,
  title,
});
